import src from "IMAGE";
export default { src, width: 2407, height: 359, blurWidth: 0, blurHeight: 0};
